import React, { useState } from 'react';
import { Box, Button, Heading, Layer, TextInput } from 'grommet';
import { AddCircle, Close } from 'grommet-icons';
import PropTypes from 'prop-types';
import { PipelineService } from '@enrich/shared-lib';

export const AddPipelineReportRecipientButton = ({
    pipelineId,
    recipients = [],
}) => {
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <Button
                secondary
                label=<span>
                    <AddCircle size="small" color="enrich-blue" /> Add
                </span>
                onClick={() => setShowModal(true)}
            />
            {showModal && (
                <AddPipelineReportRecipientModal
                    pipelineId={pipelineId}
                    recipients={recipients}
                    setShowModal={setShowModal}
                />
            )}
        </>
    );
};

const AddPipelineReportRecipientModal = ({
    pipelineId,
    recipients = [],
    setShowModal,
}) => {
    const [email, setEmail] = useState('');
    const [buttonBusy, setButtonBusy] = useState();

    const addReportRecipient = async () => {
        try {
            const reportRecipients = [...recipients, email];
            setButtonBusy(true);

            await new PipelineService().update(pipelineId, {
                reportRecipients,
            });

            setShowModal(false);
            location.reload();
        } catch (error) {
            console.log(error);
        }

        setButtonBusy(false);
    };

    return (
        <Layer
            onClickOutside={() => setShowModal(false)}
            onEsc={() => setShowModal(false)}
            position="center">
            <Box
                background="white"
                pad="medium"
                round="6px"
                border={{ color: 'enrich-green-light', size: '3px' }}
                alignSelf="center"
                gap="30px">
                <Box direction="row" gap="20px" justify="between">
                    <Heading level="3" margin={{ vertical: 'none' }}>
                        Add Report Recipient
                    </Heading>
                    <Box align="end">
                        <Close
                            onClick={() => {
                                setShowModal(false);
                            }}
                            cursor="pointer"
                        />
                    </Box>
                </Box>
                <Box>
                    <Box
                        width="medium"
                        align="center"
                        round="6px"
                        background="white">
                        <TextInput
                            dropHeight="medium"
                            onChange={(event) => setEmail(event.target.value)}
                            placeholder="Email"
                            value={email}
                        />
                    </Box>
                </Box>
                <Box>
                    <Button
                        size="medium"
                        fill="horizontal"
                        primary
                        busy={buttonBusy}
                        disabled={!email.length}
                        label="Add"
                        alignSelf="center"
                        onClick={addReportRecipient}
                    />
                </Box>
            </Box>
        </Layer>
    );
};

AddPipelineReportRecipientButton.propTypes = {
    pipelineId: PropTypes.string,
    recipients: PropTypes.arrayOf(PropTypes.string),
};

AddPipelineReportRecipientModal.propTypes = {
    pipelineId: PropTypes.string,
    recipients: PropTypes.arrayOf(PropTypes.string),
    setShowModal: PropTypes.func,
};
